import store from '@/store'

export default [{
  name: 'Home',
  path: 'home',
  id: 'home',
  redirect () {
    let tela = store.getters['acesso/primeiraTela']
    if (tela) return tela.path
    return '/sem-acoes'
  },
  meta: { requireAuth: true },
  children: []
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/home.js